module.exports = __webpack_public_path__ + "static/media/Domestic_Beneficiary.f20dac2f.svg";